(function () {
  const switchEl = document.querySelector(".pet-switch");
  if (!switchEl) return;

  const choosePetEl = document.querySelector("body");
  const options = switchEl.querySelectorAll(".pet-switch__option");
  const COOKIE_NAME = "selectedPet";
  const COOKIE_DAYS = 2;

  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = "expires=" + date.toUTCString();
    document.cookie = `${name}=${value};${expires};path=/;SameSite=Lax`;
  }

  function getCookie(name) {
    const cookieName = name + "=";
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.indexOf(cookieName) === 0) {
        return cookie.substring(cookieName.length, cookie.length);
      }
    }
    return null;
  }

  function setActive(targetPet) {
    options.forEach((opt) => {
      const isActive = opt.dataset.pet === targetPet;
      opt.classList.toggle("is-active", isActive);
      opt.setAttribute("aria-checked", String(isActive));
    });
    switchEl.dataset.active = targetPet;

    if (choosePetEl) {
      choosePetEl.classList.toggle("pet-selected-dog", targetPet === "dogs");
      choosePetEl.classList.toggle("pet-selected-cat", targetPet === "cats");
    }

    setCookie(COOKIE_NAME, targetPet, COOKIE_DAYS);

    switchEl.dispatchEvent(
      new CustomEvent("pet:change", { detail: { pet: targetPet } })
    );
  }

  const savedPet = getCookie(COOKIE_NAME);
  const initialPet = savedPet || switchEl.dataset.active || "dogs";
  setActive(initialPet);

  options.forEach((opt) => {
    opt.addEventListener("click", () => setActive(opt.dataset.pet));
    opt.addEventListener("keydown", (e) => {
      if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
        e.preventDefault();
        const next = opt.dataset.pet === "dogs" ? "cats" : "dogs";
        setActive(next);
        switchEl
          .querySelector(`.pet-switch__option[data-pet="${next}"]`)
          .focus();
      }
    });
  });
})();